export default __webpack_public_path__ + "static/media/fulfillment-warehouse.538dc134.jpg";